import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const HeroLine = ({ children, delay = 0, className = "" }) => (
    <span className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
            className={`block will-change-transform ${className}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const MaskedReveal = ({ children, delay = 0, className = "" }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    return (
        <span ref={ref} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
            <motion.span
                className={`block will-change-transform ${className}`}
                initial={{ y: "115%" }}
                animate={inView ? { y: "0%" } : {}}
                transition={{ duration: 0.95, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
};

export const FadeUp = ({ children, delay = 0, y = 36, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.85, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);
